import React, { useEffect, useState } from "react";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import ProfileService from "./Services/ProfileService"; // Assuming ProfileService is in Services folder
import Swal from "sweetalert2";
import { rsaService } from "../api/auth/rsaService";
const ProfileSettings = () => {
  const patientUserId=localStorage.getItem('userId') ;// Assuming passed via state, similar to PatientSettings
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/plugins/select2/js/select2.min.js",
      "assets/js/moment.min.js",
      "assets/js/bootstrap-datetimepicker.min.js",
      "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
      "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => {
            console.log(`Loaded: ${url}`);
            resolve();
          };
          script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }

      // Now init plugins after scripts are loaded
      if (!isCancelled) {
        if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
          window.$('.datetimepicker').datetimepicker();
        }

        console.log('All scripts loaded and initialized.');
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  const updatedBy = localStorage.getItem('userId');
  const through = localStorage.getItem('userType');

  // Query for PatientUser data
  const { data: patientUserData, isLoading: isLoadingPatientUser } = useQuery({
    queryKey: ['patientUserData'],
    queryFn: async () => {
      const response = await ProfileService.getPatientUserByPatientUserId(patientUserId);
      return response;
    },
  });
  const patientUserDataReports = useMemo(
    () => patientUserData?.data?.data ?? {},
    [patientUserData]
  );

  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [phone, setPhone] = useState('');
  const [dob, setDob] = useState('');
  const [email, setEmail] = useState('');
  const [pincode, setPincode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [address, setAddress] = useState('');
  const [bloodGroup, setBloodGroup] = useState('');
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [profilePhotoCurrent,setProfilePhotoCurrent] = useState('');
  
  const [profileErrors, setProfileErrors] = useState({});
  const [isProfileSaving, setIsProfileSaving] = useState(false);
  useEffect(() => {
    if (patientUserDataReports) {
      setName(patientUserDataReports.name || '');
      setGender(patientUserDataReports.gender || '');
      setPhone(patientUserDataReports.phone || '');
      setDob(patientUserDataReports.dob || '');
      setEmail(patientUserDataReports.email || '');
      setPincode(patientUserDataReports.pincode || '');
      setCity(patientUserDataReports.city || '');
      setState(patientUserDataReports.state || '');
      setCountry(patientUserDataReports.country || '');
      setAddress(patientUserDataReports.address || '');
      setBloodGroup(patientUserDataReports.bloodGroup || '');
      setProfilePhotoCurrent(patientUserDataReports.profilePhoto || '');
      // Profile photo would be a URL or something, but for upload, handle separately
    }
  }, [patientUserDataReports]);

  const validateProfile = () => {
    const errors = {};
    if (!name) errors.name = "Name is required.";
    if (!profilePhoto && !profilePhotoCurrent) errors.profilePhoto = "Profile photo is required.";
    if (!dob) errors.dob = "Date of Birth is required.";
    if (!gender) errors.gender = "Gender is required.";
    
    if (!phone) {
      errors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(phone)) {
      errors.phone = "Phone must be exactly 10 digits.";
    }

    if (email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        errors.email = "Invalid email format.";
      }
    }

    if (!address) errors.address = "Address is required.";
    if (!city) errors.city = "City is required.";
    if (!state) errors.state = "State is required.";
    if (!country) errors.country = "Country is required.";
    
    if (!pincode) {
      errors.pincode = "Pincode is required.";
    } else if (!/^\d{6}$/.test(pincode)) {
      errors.pincode = "Pincode must be exactly 6 digits.";
    }

    setProfileErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    if (!validateProfile()) return;
    
    setIsProfileSaving(true);
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("dob", dob); // already handled by you
      formData.append("gender", gender);
      formData.append("bloodGroup", bloodGroup);
      formData.append("phone", phone);
      if (email) formData.append("email", email);
      formData.append("address", address);
      formData.append("city", city);
      formData.append("state", state);
      formData.append("country", country);
      formData.append("pincode", pincode);
      formData.append("through", through);
      formData.append("createdBy", updatedBy);
      formData.append("userEntityId", patientUserId);

      // ✅ File handling
      if (profilePhoto) {
        formData.append("profilePhoto", profilePhoto);
      }
      await ProfileService.upsertPatientUserDetails(patientUserId, formData);
      Swal.fire({ icon: "success", title: "Success!", text: "Profile updated successfully!" });
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error!", text: "Failed to update profile." });
    } finally {
      setIsProfileSaving(false);
    }
  };

  // For change password section
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [otpTimer, setOtpTimer] = useState(0); // seconds
const [isOtpDisabled, setIsOtpDisabled] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [activeTab, setActiveTab] = useState("profile");
  
  const [passwordErrors, setPasswordErrors] = useState({});
  const [isPasswordSaving, setIsPasswordSaving] = useState(false);

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      setOtp(value);
      if (value.length > 0 && value.length !== 6) {
        setOtpError("OTP must be exactly 6 digits");
      } else {
        setOtpError("");
      }
    }
  };
  const handleSendOtp = async (e) => {
    e.preventDefault();
    await ProfileService.sendOtp(patientUserId);
    setIsOtpDisabled(true);
  setOtpTimer(120);
    // Show input for OTP or something
  };
  useEffect(() => {
  let interval = null;

  if (isOtpDisabled && otpTimer > 0) {
    interval = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
  } else if (otpTimer === 0) {
    setIsOtpDisabled(false);
    clearInterval(interval);
  }

  return () => clearInterval(interval);
}, [isOtpDisabled, otpTimer]);
  const validatePasswordForm = () => {
    const errors = {};
    if (!otp || otp.length !== 6) errors.otp = "OTP must be exactly 6 digits.";
    
    if (!newPassword) {
      errors.newPassword = "New password is required.";
    } else if (newPassword.length < 8 || newPassword.length > 20) {
      errors.newPassword = "Password must be 8-20 characters.";
    }
    
    if (newPassword !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }

    setPasswordErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!validatePasswordForm()) return;

    setIsPasswordSaving(true);
    try {
      const encrypted = await rsaService.encrypt(newPassword);
      const payLoad = {
        otp: otp,
        password: encrypted.cipherText,
        rasId: encrypted.keyId
      };
      await ProfileService.changePassword(patientUserId, payLoad);
      Swal.fire({ icon: "success", title: "Success!", text: "Password changed successfully!" });
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error!", text: "Failed to change password." });
    } finally {
      setIsPasswordSaving(false);
    }
  };

 

  return (
    <>
      <div className="col-lg-8 col-xl-9">
        <nav className="settings-tab mb-1">
          <ul className="nav nav-tabs-bottom" role="tablist">
            <li className="nav-item" role="presentation">
              <a 
              href="#profileSettings"
              className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          setActiveTab("profile");
        }} >Profile</a>
            </li>
            <li className="nav-item" role="presentation">
              <a href="#changePass"  className={`nav-link ${activeTab === "password" ? "active" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          setActiveTab("password");
        }}>Change Password</a>
            </li>
          </ul>
        </nav>
        <div className="card" id="profileSettings" style={{ display: "block" }}>
          {isLoadingPatientUser ? (<div>Loading ...</div>) : (
            activeTab === "profile" && (
            <div className="card-body">
              <div className="border-bottom pb-3 mb-3">
                <h5>Profile Settings</h5>
              </div>
              <form onSubmit={handleProfileSubmit} noValidate>
                <div className="setting-title">
                  <h6>Information</h6>
                </div>
                <div className="setting-card">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Profile Photo</label>
                        <input type="file" className={`form-control ${profileErrors.profilePhoto ? 'is-invalid' : ''}`} onChange={(e) => { setProfilePhoto(e.target.files[0]); if(profileErrors.profilePhoto) setProfileErrors({...profileErrors, profilePhoto: null}); }} />
                        {profileErrors.profilePhoto && <div className="invalid-feedback">{profileErrors.profilePhoto}</div>}
                        {profilePhoto && <img src={URL.createObjectURL(profilePhoto)} alt="Profile Preview" style={{ width:'100px'}} 
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/user12.jpg";
  }}/>}

                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Profile Photo</label>
                        {/* <input type="file" className="form-control" onChange={(e) => setProfilePhoto(e.target.files[0])} /> */}
                        {profilePhotoCurrent && <img src={`${serverConfig.BASE_URL}/uploads/patientProfiles/${profilePhotoCurrent}`} alt="Profile Preview" style={{ width:'100px',marginLeft:'20px'}}
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/user12.jpg";
  }} />}

                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input type="text" className={`form-control ${profileErrors.name ? 'is-invalid' : ''}`} value={name} onChange={(e) => { setName(e.target.value); if (profileErrors.name) setProfileErrors({...profileErrors, name: null}); }} />
                        {profileErrors.name && <div className="invalid-feedback">{profileErrors.name}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Date of Birth </label>
                        <input type="date" className={`form-control ${profileErrors.dob ? 'is-invalid' : ''}`} value={dob} onChange={(e) => { setDob(e.target.value); if (profileErrors.dob) setProfileErrors({...profileErrors, dob: null}); }} />
                        {profileErrors.dob && <div className="invalid-feedback">{profileErrors.dob}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Gender</label>
                        <select className={`select form-control ${profileErrors.gender ? 'is-invalid' : ''}`} value={gender} onChange={(e) => { setGender(e.target.value); if (profileErrors.gender) setProfileErrors({...profileErrors, gender: null}); }}>
                          <option value="">Select</option>
                          <option value="MALE">MALE</option>
                          <option value="FEMALE">FEMALE</option>
                          <option value="OTHERS">OTHERS</option>
                        </select>
                        {profileErrors.gender && <div className="invalid-feedback">{profileErrors.gender}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Blood Group</label>
                        <select className="select form-control" value={bloodGroup} onChange={(e) => setBloodGroup(e.target.value)}>
                          <option>Select</option>
                          <option>B+ve</option>
                          <option>AB+ve</option>
                          <option>B-ve</option>
                          <option>O+ve</option>
                          <option>O-ve</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input type="text" className={`form-control ${profileErrors.phone ? 'is-invalid' : ''}`} value={phone} onChange={(e) => { const val = e.target.value; if (/^\d*$/.test(val) && val.length <= 10) { setPhone(val); if (profileErrors.phone) setProfileErrors({...profileErrors, phone: null}); } }} />
                        {profileErrors.phone && <div className="invalid-feedback">{profileErrors.phone}</div>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email Address </label>
                        <input type="email" className={`form-control ${profileErrors.email ? 'is-invalid' : ''}`} value={email} onChange={(e) => { setEmail(e.target.value); if (profileErrors.email) setProfileErrors({...profileErrors, email: null}); }} />
                        {profileErrors.email && <div className="invalid-feedback">{profileErrors.email}</div>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="setting-title">
                  <h6>Address</h6>
                </div>
                <div className="setting-card">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input type="text" className={`form-control ${profileErrors.address ? 'is-invalid' : ''}`} value={address} onChange={(e) => { setAddress(e.target.value); if (profileErrors.address) setProfileErrors({...profileErrors, address: null}); }} />
                        {profileErrors.address && <div className="invalid-feedback">{profileErrors.address}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">City </label>
                        <input type="text" className={`form-control ${profileErrors.city ? 'is-invalid' : ''}`} value={city} onChange={(e) => { setCity(e.target.value); if (profileErrors.city) setProfileErrors({...profileErrors, city: null}); }} />
                        {profileErrors.city && <div className="invalid-feedback">{profileErrors.city}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">State </label>
                        <input type="text" className={`form-control ${profileErrors.state ? 'is-invalid' : ''}`} value={state} onChange={(e) => { setState(e.target.value); if (profileErrors.state) setProfileErrors({...profileErrors, state: null}); }} />
                        {profileErrors.state && <div className="invalid-feedback">{profileErrors.state}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Country </label>
                        <input type="text" className={`form-control ${profileErrors.country ? 'is-invalid' : ''}`} value={country} onChange={(e) => { setCountry(e.target.value); if (profileErrors.country) setProfileErrors({...profileErrors, country: null}); }} />
                        {profileErrors.country && <div className="invalid-feedback">{profileErrors.country}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Pincode </label>
                        <input type="text" className={`form-control ${profileErrors.pincode ? 'is-invalid' : ''}`} value={pincode} onChange={(e) => { const val = e.target.value; if (/^\d*$/.test(val) && val.length <= 6) { setPincode(val); if (profileErrors.pincode) setProfileErrors({...profileErrors, pincode: null}); } }} />
                        {profileErrors.pincode && <div className="invalid-feedback">{profileErrors.pincode}</div>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-btn text-end">
                  <button onClick={(e) => { e.preventDefault(); }} className="btn btn-md btn-light rounded-pill">Cancel</button>
                  <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill" disabled={isProfileSaving}>
                    {isProfileSaving ? 'Loading...' : 'Save Changes'}
                  </button>
                </div>
              </form>
            </div>)
          )}
        </div>
        {activeTab === "password" && (
        <div className="card">
          <div className="card-body">
            <div className="border-bottom pb-3 mb-3">
              <h5>Change Password</h5>
            </div>
            <form onSubmit={handleChangePassword}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">OTP <span className="text-danger">*</span></label>
                    <input type="text" className={`form-control ${(otpError || passwordErrors.otp) ? 'is-invalid' : ''}`} value={otp} onChange={(e) => { handleOtpChange(e); if (passwordErrors.otp) setPasswordErrors({...passwordErrors, otp: null}); }} maxLength={6} />
                    {(otpError || passwordErrors.otp) && <div className="invalid-feedback d-block">{otpError || passwordErrors.otp}</div>}
                  </div>
                  <button
  type="button"
  onClick={handleSendOtp}
  disabled={isOtpDisabled}
  className="btn btn-md btn-primary-gradient rounded-pill"
>
  {isOtpDisabled ? `Resend OTP (${otpTimer}s)` : "Send OTP"}
</button>
                  <div className="mb-3">
                    <label className="form-label">New Password <span className="text-danger">*</span></label>
                    <div className="pass-group">
                      <input type={showNewPassword ? "text" : "password"} className={`form-control pass-input ${passwordErrors.newPassword ? 'is-invalid' : ''}`} value={newPassword} onChange={(e) => { setNewPassword(e.target.value); if (passwordErrors.newPassword) setPasswordErrors({...passwordErrors, newPassword: null}); }} />
                      <span
      className={`feather-eye${showNewPassword ? "" : "-off"} toggle-password`}
      onClick={() => setShowNewPassword(!showNewPassword)}
      style={{ cursor: "pointer" }}
    />
                    </div>
                    {passwordErrors.newPassword && <div className="invalid-feedback d-block">{passwordErrors.newPassword}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                    <div className="pass-group">
                      <input  type={showConfirmPassword ? "text" : "password"} className={`form-control pass-input-sub ${passwordErrors.confirmPassword ? 'is-invalid' : ''}`} value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); if (passwordErrors.confirmPassword) setPasswordErrors({...passwordErrors, confirmPassword: null}); }} />
                      <span
      className={`feather-eye${showConfirmPassword ? "" : "-off"} toggle-password-sub`}
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
      style={{ cursor: "pointer" }}
    />
                    </div>
                    {passwordErrors.confirmPassword && <div className="invalid-feedback d-block">{passwordErrors.confirmPassword}</div>}
                  </div>
                </div>
              </div>
              <div className="modal-btn border-top pt-3 text-end">
                <button onClick={(e) => { e.preventDefault(); }} className="btn btn-md btn-light rounded-pill">Cancel</button>
                <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill" disabled={isPasswordSaving}>
                  {isPasswordSaving ? 'Loading...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>)}
      </div>
    </>
  );
};
export default ProfileSettings;